import { useEffect } from "react";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { WorkPlaceDto } from "src/dtos/workplace/workPlaceDto";
import { CustomerResponseDto, EmployeeDto, ItemDto } from "src/types/base";


//customCd 코드 검증 함수
export const validateCustomCd = (validateCustomCd: string, customCdList: CustomerResponseDto[]) => {

	const customCdInfo = customCdList.find(value => value.customCd === validateCustomCd);

	return customCdInfo ? true : false;
}

export const validateEmployeeCd = (validateEmployeeCd: string, employeeCdList: EmployeeDto[]) => {

	const employeeCdInfo = employeeCdList.find(value => value.empNo === validateEmployeeCd);

	return employeeCdInfo ? true : false;
}

export const validateWorkPlaceCd = (validateWorkPlaceCd: string, workPlaceCdList: WorkPlaceDto[]) => {

	const workPlaceCdInfo = workPlaceCdList.find(value => value.workplaceCd === validateWorkPlaceCd);

	return workPlaceCdInfo ? true : false;
}

export const validateWareHouseCd = (validateWareHouseCd: string, wareHouseCdList: WareHouseDto[]) => {

	const wareHouseCdInfo = wareHouseCdList.find(value => value.warehouseCd === validateWareHouseCd);

	return wareHouseCdInfo ? true : false;
}